import * as Sentry from "@sentry/vue";

// message should be in json format
export const sentryLog = (error, message = null) => {
  try {
    Sentry.captureException(error, {"extra": message});
  } catch (ex) {
    console.log("error logging to sentry", ex);
  }
}